Vue.component('page-home', require('./components/pages/home.vue').default);
Vue.component('page-group', require('./components/pages/group.vue').default);
Vue.component('page-board', require('./components/pages/board.vue').default);
Vue.component('time-card', require('./components/time.vue').default);
Vue.component('score-card', require('./components/score.vue').default);
Vue.component('permalink', require('./components/permalink.vue').default);